<template>
  <div class="stepper-content">
    <v-row>
      <v-col class="d-flex">
        <h3>保守連絡先①</h3>
        <app-badge :is-info="false" item="" />
      </v-col>
    </v-row>
    <!-- 保守連絡先①-会社名/部署名 -->
    <v-row class="mb-2">
      <v-col>
        <app-badge
          item="会社名/部署名"
          :is-required="false"
          :msg="
            $filter.message('info_full_width_alpha_sign_num_max', {
              sign: '. _ ! ? { } + - * / =  % $ & ^ ` ~ | @ ( ) : ; < > [ ]',
              max: 20,
            })
          "
          placement="end"
        />
        <validation-provider
          name="company1"
          label="会社名/部署名"
          v-model="cpaNwSetting.maintenanceContact1!.company"
          :rules="{
            required: true,
            is_not_include_special_char: true,
            max: { length: 20 },
          }"
          v-slot="{ componentField, errorMessage, meta }"
        >
          <app-form-input
            v-bind="componentField"
            :field-meta="meta"
            :error-messages="errorMessage"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <!-- 保守連絡先①-担当者名 -->
    <v-row class="mb-2">
      <v-col>
        <app-badge
          item="担当者名"
          :is-required="false"
          :msg="
            $filter.message('info_full_width_alpha_sign_num_max', {
              sign: '. _ ! ? { } + - * / =  % $ & ^ ` ~ | @ ( ) : ; < > [ ]',
              max: 20,
            })
          "
          placement="end"
        />
        <validation-provider
          name="name1"
          label="担当者名"
          v-model="cpaNwSetting.maintenanceContact1!.name"
          :rules="{
            required: true,
            is_not_include_special_char: true,
            max: { length: 20 },
          }"
          v-slot="{ componentField, errorMessage, meta }"
        >
          <app-form-input
            v-bind="componentField"
            :field-meta="meta"
            :error-messages="errorMessage"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <!-- 保守連絡先①-電話番号 -->
    <v-row class="mb-2">
      <v-col>
        <app-badge
          item="電話番号"
          :is-required="false"
          :msg="$filter.message('info_tel', { max: 11 })"
          placement="end"
        />
        <validation-provider
          name="phone1"
          label="電話番号"
          v-model="cpaNwSetting.maintenanceContact1!.phone"
          :rules="{ required: true, is_phone_number: { max: 11 } }"
          v-slot="{ componentField, errorMessage, meta }"
        >
          <app-form-input
            v-bind="componentField"
            :field-meta="meta"
            :error-messages="errorMessage"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <!-- 保守連絡先①-メールアドレス -->
    <v-row class="mb-2">
      <v-col>
        <app-badge
          item="メールアドレス"
          :is-required="false"
          :msg="
            $filter.message('info_sign_num_max', {
              sign: '. _ ! ? { } + - * / = # % $ & ^ ` ~ | @',
              max: 127,
            })
          "
          placement="end"
        />
        <validation-provider
          name="email1"
          label="メールアドレス"
          v-model="cpaNwSetting.maintenanceContact1!.email"
          :rules="{ required: true, max: { length: 127 }, is_email: true }"
          v-slot="{ componentField, errorMessage, meta }"
        >
          <app-form-input
            v-bind="componentField"
            :field-meta="meta"
            :error-messages="errorMessage"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <h3 class="mt-5 mb-2">保守連絡先②</h3>
    <!-- 保守連絡先②-会社名/部署名 -->
    <v-row class="mb-2">
      <v-col>
        <app-badge
          item="会社名/部署名"
          :is-required="false"
          :msg="
            $filter.message('info_full_width_alpha_sign_num_max', {
              sign: '. _ ! ? { } + - * / =  % $ & ^ ` ~ | @ ( ) : ; < > [ ]',
              max: 20,
            })
          "
          placement="end"
        />
        <validation-provider
          name="company2"
          label="会社名/部署名"
          v-model="cpaNwSetting.maintenanceContact2!.company"
          :rules="{ is_not_include_special_char: true, max: { length: 20 } }"
          v-slot="{ componentField, errorMessage, meta }"
        >
          <app-form-input
            v-bind="componentField"
            :field-meta="meta"
            :error-messages="errorMessage"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <!-- 保守連絡先②-担当者名 -->
    <v-row class="mb-2">
      <v-col>
        <app-badge
          item="担当者名"
          :is-required="false"
          :msg="
            $filter.message('info_full_width_alpha_sign_num_max', {
              sign: '. _ ! ? { } + - * / =  % $ & ^ ` ~ | @ ( ) : ; < > [ ]',
              max: 20,
            })
          "
          placement="end"
        />
        <validation-provider
          name="name2"
          label="担当者名"
          v-model="cpaNwSetting.maintenanceContact2!.name"
          :rules="{ is_not_include_special_char: true, max: { length: 20 } }"
          v-slot="{ componentField, errorMessage, meta }"
        >
          <app-form-input
            v-bind="componentField"
            :field-meta="meta"
            :error-messages="errorMessage"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <!-- 保守連絡先②-電話番号 -->
    <v-row class="mb-2">
      <v-col>
        <app-badge
          item="電話番号"
          :is-required="false"
          :msg="$filter.message('info_tel', { max: 11 })"
          placement="end"
        />
        <validation-provider
          name="phone2"
          label="電話番号"
          v-model="cpaNwSetting.maintenanceContact2!.phone"
          :rules="{ is_phone_number: { max: 11 } }"
          v-slot="{ componentField, errorMessage, meta }"
        >
          <app-form-input
            v-bind="componentField"
            :field-meta="meta"
            :error-messages="errorMessage"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <!-- 保守連絡先②-メールアドレス -->
    <v-row class="mb-2">
      <v-col>
        <app-badge
          item="メールアドレス"
          :is-required="false"
          :msg="
            $filter.message('info_sign_num_max', {
              sign: '. _ ! ? { } + - * / = # % $ & ^ ` ~ | @',
              max: 127,
            })
          "
          placement="end"
        />
        <validation-provider
          name="email2"
          label="メールアドレス"
          v-model="cpaNwSetting.maintenanceContact2!.email"
          :rules="{ max: { length: 127 }, is_email: true }"
          v-slot="{ componentField, errorMessage, meta }"
        >
          <app-form-input
            v-bind="componentField"
            :field-meta="meta"
            :error-messages="errorMessage"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CpaNwDetail } from "@/apis/Cpa5gSaApi";

export default defineComponent({
  name: "SaNwEditStepper2",
  props: {
    /** 親コンポーネントで保持してるCPA NW情報 */
    value: {
      type: Object as PropType<CpaNwDetail>,
      required: true,
    },
  },
  data() {
    return {
      cpaNwSetting: this.value,
    };
  },
  computed: {
    /**
     * 保守連絡先②内の項目が全て入力されているかチェック
     * true: 正常 全て入力されている・全て未入力 false: エラー 一部の項目が未入力
     */
    isFilledAllField(): boolean {
      // 保守連絡先②内の項目いずれかが入力されていればチェックする
      if (
        Object.values(this.cpaNwSetting.maintenanceContact2!).some((v) => !!v)
      ) {
        // 保守連絡先②が全て入力されているかチェックする
        return Object.values(this.cpaNwSetting.maintenanceContact2!).every(
          (v) => !!v
        );
      }
      // 全て未入力なので通過
      return true;
    },
  },
  watch: {
    /** 親からのForm情報更新を反映 */
    value(newValue: CpaNwDetail) {
      this.cpaNwSetting = newValue;
    },
    /** isFilledAllFieldが変更されたら実行し、呼び出し元(SaNwEdit.vue)へ結果を返す */
    isFilledAllField(newValue: boolean) {
      this.$emit("result", newValue);
    },
  },
});
</script>
